import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {UpdateComparatorAdsService} from '../Services/UpdateComparatorAdsService.js'

class RemoveComparatorAdsUseCase extends UseCase {
  #service

  #handleError(error) {
    return Promise.reject(
      DomainSharedError.isDomainError({error}) ? error : DomainSharedError.createGenericError({cause: error})
    )
  }

  constructor({service}) {
    super()
    this.#service = service
  }

  static create() {
    return new RemoveComparatorAdsUseCase({service: UpdateComparatorAdsService.create()})
  }

  @tracer({metric: 'RemoveComparatorAdsUseCase#execute'})
  @AsyncInlineError()
  async execute({adId}) {
    try {
      const [error, response] = await this.#service.removeAd({adId})
      return error ? this.#handleError(error) : response
    } catch (error) {
      return this.#handleError(error)
    }
  }
}

export const factory = RemoveComparatorAdsUseCase.create
